/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {SetThemeVariant} from './theme.actions';
import {DashGisUtil} from '../../../../modules/shared/dash-gis-util';
import { Injectable } from '@angular/core';

export type ThemeVariant = 'light' | 'dark';

export interface ThemeStateModel {
    variant: ThemeVariant;
}

@State<ThemeStateModel>({
    name: 'theme',
    defaults: {
        variant: 'light'
    }
})
@Injectable()
export class ThemeState {

    @Selector() static variant(state: ThemeStateModel) { return state.variant; }

    @Action(SetThemeVariant)
    setVariant({getState, setState}: StateContext<ThemeStateModel>, action: SetThemeVariant) {
        const state = DashGisUtil.clone(getState());
        state.variant = action.payload.variant;
        setState(state);
    }
}
